
export const LOAD_FIRMWARE_DATA_IN_PROGRESS = "LOAD_FIRMWARE_DATA_IN_PROGRESS";
export const loadFirmwareDataInProgress = () => ({
  type: LOAD_FIRMWARE_DATA_IN_PROGRESS,
});

export const LOAD_FIRMWARE_DATA_SUCCESS = "LOAD_FIRMWARE_DATA_SUCCESS";
export const loadFirmwareDataSuccess = (data) => ({
  type: LOAD_FIRMWARE_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_FIRMWARE_DATA_FAILURE = "LOAD_FIRMWARE_DATA_FAILURE";
export const loadFirmwareDataFailure = () => ({
  type: LOAD_FIRMWARE_DATA_FAILURE,
});


export const LOAD_CONFIG_DATA_IN_PROGRESS = "LOAD_CONFIG_DATA_IN_PROGRESS";
export const loadConfigDataInProgress = () => ({
  type: LOAD_CONFIG_DATA_IN_PROGRESS,
});

export const LOAD_CONFIG_DATA_SUCCESS = "LOAD_CONFIG_DATA_SUCCESS";
export const loadConfigDataSuccess = (data) => ({
  type: LOAD_CONFIG_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_DEFAULT_CONFIG_FILE_DATA_SUCCESS = "LOAD_DEFAULT_CONFIG_FILE_DATA_SUCCESS";
export const loadDefaultConfigFileDataSuccess = (data) => ({
  type: LOAD_DEFAULT_CONFIG_FILE_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_CONFIG_DATA_FAILURE = "LOAD_CONFIG_DATA_FAILURE";
export const loadConfigDataFailure = () => ({
  type: LOAD_CONFIG_DATA_FAILURE,
});

export const LOAD_DEVICE_DATA_IN_PROGRESS = "LOAD_DEVICE_DATA_IN_PROGRESS";
export const loadDeviceDataInProgress = () => ({
  type: LOAD_DEVICE_DATA_IN_PROGRESS,
});

export const FILES_OPERATION_COMPLETED = "FILES_OPERATION_COMPLETED";
export const filesOperationCompleted = () => ({
  type: FILES_OPERATION_COMPLETED,
});

export const OPEN_FIRMWARE_DIALOG = "OPEN_FIRMWARE_DIALOG";
export const openFirmwareDialog = () => ({
  type: OPEN_FIRMWARE_DIALOG,
});

export const CLOSE_FIRMWARE_DIALOG = "CLOSE_FIRMWARE_DIALOG";
export const closeFirmwareDialog = () => ({
  type: CLOSE_FIRMWARE_DIALOG,
});

export const OPEN_CONFIG_DIALOG = "OPEN_CONFIG_DIALOG";
export const openConfigDialog = () => ({
  type: OPEN_CONFIG_DIALOG,
});

export const CLOSE_CONFIG_DIALOG = "CLOSE_CONFIG_DIALOG";
export const closeConfigDialog = () => ({
  type: CLOSE_CONFIG_DIALOG,
});


export const SUCCESS_MESSAGE_DIALOG_BOX = "SUCCESS_MESSAGE_DIALOG_BOX";
export const successMessageDialogBox = (data) => ({
  type: SUCCESS_MESSAGE_DIALOG_BOX,
  payload: { data },
});

export const SUCCESS_MESSAGE_DIALOG_BOX_CLOSE = "SUCCESS_MESSAGE_DIALOG_BOX_CLOSE";
export const successMessageDialogBoxClose = () => ({
  type: SUCCESS_MESSAGE_DIALOG_BOX_CLOSE,
});


export const ERROR_MESSAGE_DIALOG_BOX = "ERROR_MESSAGE_DIALOG_BOX";
export const errorMessageDialogBox = (data) => ({
  type: ERROR_MESSAGE_DIALOG_BOX,
  payload: { data },
});

export const ERROR_MESSAGE_DIALOG_BOX_CLOSE = "ERROR_MESSAGE_DIALOG_BOX_CLOSE";
export const errorMessageDialogBoxClose = () => ({
  type: ERROR_MESSAGE_DIALOG_BOX_CLOSE,
});
